import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { iusuario } from '../models/iusuario.model';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';

@Injectable({
    providedIn: 'root'
})
export class SunnatService {

    constructor(private apiService: ApiService) { }

    getsunat(): Observable<any> {
        this.apiService.setUrlPathApi('estado/envioSunat/buscar');
        return this.apiService.execGetQueryJson('')
    }

 /*@Path("/estado/envioSunat")
public interface EstadoEnvioSunatRestService {

    @GET
    @Path("/buscar")
    @Produces(MediaType.APPLICATION_JSON)
    public Response buscar(@HeaderParam("Authorization") String auth); */ 
} 